
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frameworks",
      function () {
        return require("private-next-pages/frameworks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frameworks"])
      });
    }
  